import {WorkflowFieldVariableItemTypes} from 'appRedux/actions/workflow/types';

import {MdxEditorCustomButtonType} from 'components/MdxEditorField/helper';
import {getWorkflowVariableButtons} from 'components/Forms/Workflow/workflowStatusEvent/helper';

export const getButtonsForCalendarTemplate = (
    currentWorkflowVariables: WorkflowFieldVariableItemTypes[],
): MdxEditorCustomButtonType[] => {
    const results: MdxEditorCustomButtonType[] = [
        {
            title: 'orguser.requesterCase.name',
            markdown: '{{ username }}',
        },
        {
            title: 'orguser.requesterCase.caseLink',
            markdown: '{{ url }}',
        },
        {
            title: 'orguser.requesterCase.caseLabel',
            markdown: '{{ caseLabel }}',
        },
    ];

    return getWorkflowVariableButtons(currentWorkflowVariables, results);
};
